export const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");

export const API_URL = `${BASE_URL}/api/accounting/accounting-records/`;
export const COMMISSION_API = `${BASE_URL}/api/accounting/commission-allocations/`;
export const ORDERS_API = `${BASE_URL}/api/orders/`;
export const CLIENTS_API = `${BASE_URL}/api/clients/`;
export const CURRENCIES_API = `${BASE_URL}/api/accounting/currencies/`;
export const PROFIT_ALLOCATIONS_URL = `${BASE_URL}/api/accounting/profit-allocations/`;
export const SUPPLIER_PREPAYMENTS_URL = `${BASE_URL}/api/accounting/supplier-prepayments/`;
export const ACCOUNTS_API = `${BASE_URL}/api/finances/accounts/`;

export const ALLOC_DOCS_URL = (id) => `${BASE_URL}/api/accounting/allocations/${id}/documents/`;
export const ALLOC_DOCS_DELETE = `${BASE_URL}/api/accounting/allocation-documents/`;
export const COMM_DOCS_URL = (id) => `${COMMISSION_API}${id}/documents/`;
export const COMM_DOCS_DELETE = `${BASE_URL}/api/accounting/commission-allocation-documents/`;

export const EPS = 0.01;